const titles = [
  {
    name: 'Hero Title',
    description: 'Tondo Light / Font Size: 80px / Line-Height: 80px / Spacing: -0.8',
    className: '.hero-title',
    type: 'titles',
  },
  {
    name: 'Main Title',
    description: 'Tondo Light / Font Size: 60px / Line-Height: 60px / Spacing: -0.6',
    className: '.main-title',
    type: 'titles',
  },
  {
    name: 'Main Subtitle',
    description: 'Tondo Light / Font Size: 48px / Line-Height: 50px / Spacing: -0.4',
    className: '.main-subtitle',
    type: 'titles',
  },
  {
    name: 'Section Title',
    description: 'Tondo Light / Font Size: 36px / Line-Height: 40px / Spacing: -0.1',
    className: '.section-title',
    type: 'titles',
  },
  {
    name: 'Section Subtitle',
    description: 'Tondo Light / Font Size: 30px / Line-Height: 34px / Spacing: 0',
    className: '.section-subtitle',
    type: 'titles',
  },
  {
    name: 'Hotspot Title',
    description: 'Tondo Light / Font Size: 24px / Line-Height: 28px / Spacing: 0',
    className: '.hotspot-title',
    type: 'titles',
  },
];

export default titles;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/constants/titles.js